import { ExchangeRatesResponse } from '../types/dto/response/exchange-rates-response';
import { ExchangeRates } from '../types/exchange-rates';

/**
 * Maps exchange rates response from API to application domain model.
 */
export const mapExchangeRatesFromResponse = (response: ExchangeRatesResponse): ExchangeRates => {
  return {
    rates: response.rates,
  };
};
